import { useQuery } from '@tanstack/react-query';
import * as meetingService from '../services/meeting.service';
import * as desenvolvimentoService from '../services/desenvolvimento.service';

export function useMeeting(ataId: string) {
  return useQuery({
    queryKey: ['meeting', ataId],
    queryFn: async () => {
      const [ata, desenvolvimentos] = await Promise.all([
        meetingService.getMeetingById(ataId),
        desenvolvimentoService.getDesenvolvimentosByAtaId(ataId),
      ]);
      return { ata, desenvolvimentos };
    },
    enabled: !!ataId,
    staleTime: 3 * 60 * 1000, // 3 minutos para atas (mudam mais frequentemente)
  });
}

export function useMeetingsByProject(projectId: string) {
  return useQuery({
    queryKey: ['meetings', 'project', projectId],
    queryFn: () => meetingService.getProjectMeetings(projectId),
    enabled: !!projectId,
    staleTime: 3 * 60 * 1000,
    select: (data) => ({
      meetings: [...data.meetings].sort((a, b) => b.number - a.number),
      permission: data.permission,
    }),
  });
}
